var map = {
	"./accessories.svg": "25ef",
	"./arrow.svg": "21e2",
	"./assembly.svg": "2737",
	"./duplikuj.svg": "fdba",
	"./edycja.svg": "4660",
	"./ikonka-06.svg": "9075",
	"./ikonka-09.svg": "4d47",
	"./plus.svg": "eb38",
	"./service.svg": "df0e",
	"./ustawienia.svg": "9fa5",
	"./usun.svg": "f8ff",
	"./vetrex-ikony/copy_filled_24.svg": "2228",
	"./vetrex-ikony/copy_filled_32.svg": "da84a",
	"./vetrex-ikony/copy_filled_64.svg": "0d2e",
	"./vetrex-ikony/copy_outlined_24.svg": "0cb9",
	"./vetrex-ikony/copy_outlined_32.svg": "7f5f",
	"./vetrex-ikony/copy_outlined_64.svg": "20bd",
	"./vetrex-ikony/edit_24.svg": "6f08",
	"./vetrex-ikony/edit_32.svg": "e46f",
	"./vetrex-ikony/edit_64.svg": "1c6a",
	"./vetrex-ikony/expand_24.svg": "1b6f",
	"./vetrex-ikony/expand_32.svg": "7d01",
	"./vetrex-ikony/expand_64-1.svg": "af02",
	"./vetrex-ikony/expand_64.svg": "534d",
	"./vetrex-ikony/list_filled_24.svg": "4d18",
	"./vetrex-ikony/list_filled_64.svg": "2291",
	"./vetrex-ikony/list_outlined_24.svg": "ea65",
	"./vetrex-ikony/list_outlined_32-1.svg": "d1ae",
	"./vetrex-ikony/list_outlined_32.svg": "51e2",
	"./vetrex-ikony/list_outlined_64.svg": "dd9a",
	"./vetrex-ikony/no_filter_filled_24.svg": "2858",
	"./vetrex-ikony/no_filter_filled_32.svg": "4781",
	"./vetrex-ikony/no_filter_filled_64.svg": "95e1",
	"./vetrex-ikony/no_filter_outlined_24.svg": "6e1c",
	"./vetrex-ikony/no_filter_outlined_32.svg": "8c36",
	"./vetrex-ikony/no_filter_outlined_64.svg": "137a",
	"./vetrex-ikony/print_filled_24.svg": "ff73",
	"./vetrex-ikony/print_filled_32.svg": "81e1",
	"./vetrex-ikony/print_filled_64.svg": "fa94",
	"./vetrex-ikony/print_outlined_24.svg": "a85e",
	"./vetrex-ikony/print_outlined_32.svg": "ce37",
	"./vetrex-ikony/print_outlined_64.svg": "9bca",
	"./vetrex-ikony/save_filled_24.svg": "fac0",
	"./vetrex-ikony/save_filled_32.svg": "b285",
	"./vetrex-ikony/save_filled_64.svg": "339a",
	"./vetrex-ikony/save_outlined_24.svg": "6df6",
	"./vetrex-ikony/save_outlined_32.svg": "0cfa",
	"./vetrex-ikony/save_outlined_64.svg": "abd4",
	"./vetrex-ikony/settings_filled_24.svg": "71cf",
	"./vetrex-ikony/settings_filled_32.svg": "2f68",
	"./vetrex-ikony/settings_filled_64.svg": "5beb",
	"./vetrex-ikony/settings_outlined_24.svg": "24f0",
	"./vetrex-ikony/settings_outlined_32.svg": "13e9d",
	"./vetrex-ikony/settings_outlined_64.svg": "ac93",
	"./vetrex-ikony/statistics_filled_24.svg": "b076",
	"./vetrex-ikony/statistics_filled_32.svg": "cf03",
	"./vetrex-ikony/statistics_filled_64.svg": "58cc",
	"./vetrex-ikony/statistics_outline_64.svg": "32dc",
	"./vetrex-ikony/statistics_outlined_24.svg": "1507",
	"./vetrex-ikony/statistics_outlined_32.svg": "d344",
	"./vetrex-ikony/trash_filled_24.svg": "fbca",
	"./vetrex-ikony/trash_filled_32.svg": "fb74",
	"./vetrex-ikony/trash_filled_64.svg": "c4d5",
	"./vetrex-ikony/trash_outlined_24.svg": "36ba",
	"./vetrex-ikony/trash_outlined_32.svg": "cc42",
	"./vetrex-ikony/trash_outlined_64.svg": "7cf2",
	"./wyszukiwanie.svg": "02f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";